import Tabs from "../Tabs";
import VideoQuestionsLibrary from "./VideoQuestionsLibrary";
import { MediaLibraryProvider, useMediaLibrary } from "./MediaLibraryContext";
import { useTranslations } from "../context/TranslationContext";

const MediaLibrary = ({ mediaLibraryMetadata, handleSelectMedia, ...props }) => {
    return (
        <MediaLibraryProvider
            metadata={mediaLibraryMetadata}
            handleSelectMedia={handleSelectMedia}
        >
            <MediaLibraryComponent {...props} />
        </MediaLibraryProvider>
    );
};

const MediaLibraryComponent = () => {
    const { t } = useTranslations();
    const { mediaLibraryMetadata } = useMediaLibrary();

    const extractMetadataKeysToArrays = (metadata) => ({
        mediaLibraryIds: metadata.map(({ id }) => id),
        mediaLibraryTitles: metadata.map(({ title }) => title),
    });

    const { mediaLibraryIds, mediaLibraryTitles } = extractMetadataKeysToArrays(mediaLibraryMetadata);

    const mediaLibraryDataMapping = {
        'video_questions': {},
    }

    const mediaLibraryLayoutMapping = {
        'video_questions': VideoQuestionsLibrary,
    };

    const tabsProps = {
        tabIDs: mediaLibraryIds,
        tabLabels: mediaLibraryTitles,
        data: mediaLibraryDataMapping,
        layoutMapping: mediaLibraryLayoutMapping,
    };

    return (
        <>
            <Tabs {...tabsProps} />
        </>
    );
};

export default MediaLibrary;